import {
  ContentSwitcher,
  GridViewIcon,
  TableViewIcon,
  type ContentSwitcherSize,
} from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";

export type DatasetViewMode = "grid" | "table";

export type DatasetViewModeToggleProps = {
  value: DatasetViewMode;
  onChange: (value: DatasetViewMode) => void;
  size?: ContentSwitcherSize;
  className?: string;
};

// grid/table 뷰 전환. c6 ContentSwitcher 의 아이콘 전용 세그먼트(GridViewIcon/TableViewIcon)를 쓴다.
// size 값:
//   - md(기본): 트랙이 2rem 이다. 옆의 md IconButton(새로고침 등)과 높이가 같다.
//   - sm: sm 컨트롤 기준의 촘촘한 스트립(BulkActionBar 등)에 맞춘다.
export function DatasetViewModeToggle({
  value,
  onChange,
  size = "md",
  className,
}: DatasetViewModeToggleProps): ReactNode {
  return (
    <ContentSwitcher
      label="Dataset 보기 방식"
      size={size}
      value={value}
      onValueChange={(next) => onChange(next as DatasetViewMode)}
      className={className}
      options={[
        { value: "grid", icon: <GridViewIcon />, ariaLabel: "그리드 보기" },
        { value: "table", icon: <TableViewIcon />, ariaLabel: "테이블 보기" },
      ]}
    />
  );
}
